import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Strip any platform-injected branding badge that gets added at runtime.
// Belt-and-suspenders to the CSS rule in index.css that hides the same node.
function stripPlatformBadges() {
  document.querySelectorAll(
    '#emergent-badge, a[href*="emergent.sh"], a[href*="emergent-badge"]'
  ).forEach((n) => n.remove());
}
stripPlatformBadges();
new MutationObserver(stripPlatformBadges).observe(document.documentElement, {
  childList: true, subtree: true,
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
